<template>
  <form class="kompa-internet-routers-form uk-form-stacked" @submit.prevent="submit">
    <checkbox
      :disabled="!isEditable"
      :errors="form.errors.band24"
      :label="$t('fields.band24')"

      ref="band_24"
      v-model="form.model.band24"
    />

    <checkbox
      :disabled="!isEditable"
      :errors="form.errors.band5"
      :label="$t('fields.band5')"

      ref="band5"
      v-model="form.model.band5"
    />

    <checkbox
      :disabled="!isEditable"
      :errors="form.errors.wpsSupport"
      :label="$t('fields.wpsSupport')"

      ref="wpsSupport"
      v-model="form.model.wpsSupport"
    />

    <checkbox
      :disabled="!isEditable"
      :errors="form.errors.appSetup"
      :label="$t('fields.appSetup')"

      ref="appSetup"
      v-model="form.model.appSetup"
    />

    <checkbox
      :disabled="!isEditable"
      :errors="form.errors.meshSupport"
      :label="$t('fields.meshSupport')"

      ref="meshSupport"
      v-model="form.model.meshSupport"
    />

    <checkbox
      :disabled="!isEditable"
      :errors="form.errors.guestWifi"
      :label="$t('fields.guestWifi')"

      ref="guestWifi"
      v-model="form.model.guestWifi"
    />

    <checkbox
      :disabled="!isEditable"
      :errors="form.errors.display"
      :label="$t('fields.display')"

      ref="display"
      v-model="form.model.display"
    />

    <checkbox
      :disabled="!isEditable"
      :errors="form.errors.smartHub"
      :label="$t('fields.smartHub')"

      ref="smartHub"
      v-model="form.model.smartHub"
    />

    <text-input
      :disabled="!isEditable"
      :errors="form.errors.lanPorts"
      :label="$t('fields.lanPorts')"

      ref="lanPorts"
      v-model.number="form.model.lanPorts"
      min=0
      step=1
      type="number"
    />

    <text-input
      :disabled="!isEditable"
      :errors="form.errors.usbPorts"
      :label="$t('fields.usbPorts')"

      ref="usbPorts"
      v-model.number="form.model.usbPorts"
      min=0
      step=1
      type="number"
    />

    <submit-button type="primary" :disabled="!isSubmittable" />
    <cancel-button />
  </form>
</template>

<script>
import Form from '@/mixins/LegacyForm';
import KeywordListInput from '@/components/KeywordListInput';
import Checkbox from '@/components/Checkbox';

export default {
  name: 'kompa-internet-routers-form',
  components: {
    KeywordListInput,
    Checkbox,
  },
  mixins: [
    Form({
      band24: { required: false },
      band5: { required: false },
      wpsSupport: { required: false },
      appSetup: { required: false },
      meshSupport: { required: false },
      guestWifi: { required: false },
      display: { required: false },
      smartHub: { required: false },
      usbPorts: { required: false },
      lanPorts: { required: false },
    }),
  ],
  mounted() {
    this.$refs.band24.focus();
  },
};
</script>



// WEBPACK FOOTER //
// KompaInternetRoutersForm.vue?13aacc94